import { render, staticRenderFns } from "./psReturnExtractionSchemeSalse.vue?vue&type=template&id=6986bcc7&scoped=true"
import script from "./psReturnExtractionSchemeSalse.vue?vue&type=script&lang=js"
export * from "./psReturnExtractionSchemeSalse.vue?vue&type=script&lang=js"
import style0 from "./psReturnExtractionSchemeSalse.vue?vue&type=style&index=0&id=6986bcc7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6986bcc7",
  null
  
)

export default component.exports